export default __webpack_public_path__ + "static/media/brand12-dark.b9529c0d.svg";